<div *ngIf="learningObjective"class="d-flex flex-row h-100"
     [class.selected]="selected">

    <div class="py-1 pr-1" style="overflow:hidden; text-overflow: ellipsis; padding-left: 12px; display: flex; align-items: center; justify-content: center; flex-basis: 80%; text-align: center;"
         (click)="learningObjectiveSelected()">

        {{ learningObjective.title }}
        &nbsp;<span *ngIf="learningObjective.offlineTest" class="mdi mdi-content-cut"></span>

    </div>

    <div class="d-flex flex-column justify-content-between h-100"
         style="flex-basis: 20%;">
        <div class="p-1 text-center align-self-top text-secondary font-weight-bold">
                {{ learningObjective.gradeLevel }}</div>
        <div class="p-1 py-0 flex-grow-1 text-center align-self-top text-secondary">
          {{learningObjective.learningroutes.join(", ")}}
        </div>
        <div class="p-1 justify-content-center text-center text-secondary align-self-bottom">
            {{ getAbbreviation(learningObjective) }}
        </div>
    </div>


</div>
